import Context from './zIndexContext';
import Provider from './zIndexProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
